import { render } from "./TfaIcon.vue?vue&type=template&id=359c7cde"
import script from "./TfaIcon.vue?vue&type=script&lang=js"
export * from "./TfaIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__